<template>
  <div class="app-container">
    <div class="header">{{ vendor.smsc_id }}</div>
    <nav class="add-navigation d-flex flex-column flex-md-row justify-content-md-between">
      <div
        @click="$router.push({ name: 'system-admin-smsc-connection-list' })"
        class="back-link mb-3 mb-md-0"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to SMSC Connection</p>
      </div>
      <div class="buttons-wrapper">
        <div
          @click="$router.push({ name: 'system-admin-smsc-connection-list' })"
          class="secondary-button mr-2 mr-sm-3 min-w-90"
        >
          <secondary-button class="px-2 px-sm-3">Cancel</secondary-button>
        </div>
        <div class="primary-button min-w-90">
          <primary-button class="px-3" @click.native="editVendor"
            >
            <span class="d-none d-sm-block">Edit SMSC Connection</span>
            <span class="d-sm-none">Save</span>
          </primary-button
          >
        </div>
      </div>
    </nav>
    <div class="add-container">
      <span class="container-title px-3 pb-3 d-flex">Edit <span class="d-none d-sm-block px-1">SMSC Connection</span> Information</span>
      <div class="row p-3">
        <div class="col-md-6 col-12">
          <primary-input
            type="text"
            name="user name"
            class="field"
            v-model="vendor.username"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('user name') }"
            placeholder="Enter user name"
          />
          <div class="help is-danger" v-if="errors.has('user name')">
            {{ errors.first("user name") }}
          </div>
          <primary-select
            type="text"
            name="type"
            v-validate="'required'"
            v-model="vendor.type"
            :class="{ input: true, 'is-danger': errors.has('type') }"
            placeholder="type"
          >
            <option v-for="(i, k) in type" :value="i" :key="k">{{ i }}</option>
          </primary-select>
          <div v-if="errors.has('type')" class="help is-danger">
            {{ errors.first("type") }}
          </div>
          <primary-input
            type="text"
            name="smsc id"
            class="field"
            v-model="vendor.smsc_id"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('smsc id') }"
            placeholder="Enter smsc id"
          />
          <div class="help is-danger" v-if="errors.has('smsc id')">
            {{ errors.first("smsc id") }}
          </div>
          <primary-input
            type="number"
            name="throughput"
            v-model="vendor.throughput"
            class="input"
            placeholder="Enter throughput"
          />
        </div>
        <div class="col-md-6 col-12">
          <primary-input
            type="password"
            name="password"
            v-model="vendor.password"
            v-validate="'required'"
            ref="password"
            :class="{ input: true, 'is-danger': errors.has('password') }"
            placeholder="********"
          />
          <div v-if="errors.has('password')" class="help is-danger">
            {{ errors.first("password") }}
          </div>
          <primary-input
            type="text"
            name="ip"
            v-model="vendor.ip"
            v-validate="{
              required: true,
            }"
            :class="{ input: true, 'is-danger': errors.has('ip') }"
            placeholder="Enter IP"
          />
          <div v-if="errors.has('ip')" class="help is-danger">
            {{ errors.first("ip") }}
          </div>
          <primary-input
            type="text"
            name="port"
            v-model="vendor.port"
            v-validate="{
              required: true,
              regex: /^()([1-9]|[1-5]?[0-9]{2,4}|6[1-4][0-9]{3}|65[1-4][0-9]{2}|655[1-2][0-9]|6553[1-5])$/,
            }"
            :class="{ input: true, 'is-danger': errors.has('port') }"
            placeholder="Enter port"
          />
          <div v-if="errors.has('port')" class="help is-danger">
            {{ errors.first("port") }}
          </div>
          <primary-select
            v-if="vendor.type === 'http'"
            type="text"
            name="api adapter"
            v-validate="'required'"
            v-model="vendor.api_adapter_name"
            :class="{ input: true, 'is-danger': errors.has('api adapter') }"
            placeholder="api adapter"
            :options="api_adapters"
          />
          <div v-if="errors.has('type')" class="help is-danger">
            {{ errors.first("api adapter") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    EditDropzone: () => import("@/components/EditDropzone"),
  },
  data: () => ({
    api_adapters: [],
    vendor: {
      ip: null,
      username: null,
      type: "smpp",
      password: null,
      vendor_uuid: null,
      smsc_id: null,
      api_adapter_name: null,
      port: null,
      use_ssl: true,
      throughput: null
    },
    type: ["smpp", "fake", "http", "loopback", "cmpp"],
  }),
  computed: {
    ...mapGetters({
      getSmscGetter: "smsc/getSmsc",
    }),
  },
  created() {
    this.GetApiAdapterList();
    this.getSmsc();
  },
  methods: {
    ...mapActions({
      editSmsc: "smsc/editSmsc",
    }),
    async getSmsc() {
      await axios({
        url: "/smsc_connection/" + this.$route.params.id,
        params: {},
        method: "GET",
      }).then((res) => {
        this.vendor = res.data.payload;
        console.log(res.data.payload)
      });
    },
    async GetApiAdapterList() {
      let { total } = await this.$store.dispatch("GetApiAdapterList", {});
      const { items } = await this.$store.dispatch("GetApiAdapterList", {
        perPage: total,
      });
      this.api_adapters = items.map((item) => {
        return { name: item.api_adapter_name, value: item.api_adapter_name };
      });
    },
    editVendor: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        if (this.vendor.type !== "http") {
          delete this.vendor.api_adapter_name;
        }
        this.vendor.vendor_uuid = this.$route.params.id;
        this.vendor.transceiver_mode = true;
        let payload = {
          username: this.vendor.username,
          type: this.vendor.type,
          ip: this.vendor.ip,
          port: this.vendor.port,
          smsc_id: this.vendor.smsc_id,
          password: this.vendor.password,
        };
        if (this.vendor.throughput) {
          payload.throughput = this.vendor.throughput
        }
        await this.editSmsc({ payload: payload, id: this.$route.params.id });

        this.$snotify.success("SMSC connection has been edited.", {
          timeout: 6000,
        });

        this.$router.push({ name: "system-admin-smsc-connection-list" });
      } catch (err) {
        console.log(err);
        this.$error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .header {
    //padding: 15px 0;
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        white-space: nowrap;
      }
      .secondary-button {
        height: 40px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding-top: 15px;
    .container-title {
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
    }
    .row .primary-input-container {
      margin-bottom: 20px;
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .company {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
  .min-w-90 {
    min-width: 90px;
  }
</style>

